import { Typography } from "@mui/material";
import {
	BonusFlagCenter,
	BonusFlagCenterRight,
	BonusFlagLeft,
	BonusFlagRight,
	WrapperCenter,
	WrapperLeft,
	WrapperRight,
	BonusFlagSpecial,
	BonusFlagRightSmall
} from "./styled";
import { CSSProperties } from "styled-components";

const BonusFlagComponent = ({
	text,
	position = "center",
	wrapperStyle,
	bannerStyle,
	textStyle
}: {
	text: string;
	position?: string;
	wrapperStyle?: CSSProperties;
	bannerStyle?: CSSProperties;
	textStyle?: CSSProperties;
}): JSX.Element | null => {
	if (!text) {
		return null;
	}

	const getText = () => (
		<Typography style={{ ...textStyle }} variant="body1" textAlign="center">
			{text}
		</Typography>
	);

	switch (position) {
		case "center":
			return (
				<WrapperCenter style={{ ...wrapperStyle }}>
					<BonusFlagCenter style={{ ...bannerStyle }}>
						{getText()}
					</BonusFlagCenter>
				</WrapperCenter>
			);
		case "special":
			return (
				<WrapperCenter style={{ ...wrapperStyle }}>
					<BonusFlagSpecial style={{ ...bannerStyle }}>
						{getText()}
					</BonusFlagSpecial>
				</WrapperCenter>
			);
		case "center right":
			return (
				<WrapperCenter style={{ ...wrapperStyle }}>
					<BonusFlagCenterRight style={{ ...bannerStyle }}>
						{getText()}
					</BonusFlagCenterRight>
				</WrapperCenter>
			);
		case "left":
			return (
				<WrapperLeft style={{ ...wrapperStyle }}>
					<BonusFlagLeft style={{ ...bannerStyle }}>{getText()}</BonusFlagLeft>
				</WrapperLeft>
			);
		case "right":
			return (
				<WrapperRight style={{ ...wrapperStyle }}>
					<BonusFlagRight style={{ ...bannerStyle }}>
						{getText()}
					</BonusFlagRight>
				</WrapperRight>
			);
		case "right small":
			return (
				<WrapperRight style={{ ...wrapperStyle }}>
					<BonusFlagRightSmall style={{ ...bannerStyle }}>
						{getText()}
					</BonusFlagRightSmall>
				</WrapperRight>
			);
		default:
			return null;
	}
};

export default BonusFlagComponent;
